document.addEventListener('DOMContentLoaded', function () {
    // 商品ページ以外は処理しない
    if (!document.body.classList.contains('template-product')) return;

    // 指定の文字列にIDを付与する
    const targetText = '【⇓ ご注文はこちらよりお願い致します ⇓】';
    let elements = document.querySelectorAll('.product-single__description p, .product-single__description div');

    elements.forEach(function (el) {
        if (el.textContent.indexOf(targetText) !== -1) {
        el.id = 'order-link-target';
        }
    });
});